import axios from 'axios';
// import { BASE_URL } from '../helpers/constant';
import { BASE_URL } from '../helpers/constant';
import UserService from '../utils/UserService';
// import { getAuthUser } from './auth';

const client = () => {
  // const authUserData = getAuthUser();
  // const token = authUserData ? authUserData.token : '';
  const token = UserService.getToken() || '';
  const client = axios.create({
    baseURL: BASE_URL,
    headers: {
      authorization: `Bearer ${token}`,
      Accept: 'application/json',
      // "Content-Type": "application/json"
    },
  });

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check if it's a network error (server down or no internet)
      if (!error.response) {
        // Navigate to error page
        window.location.href = '/error';
        return Promise.reject({
          isNetworkError: true,
          message:
            'Unable to connect to the server. Please check your internet connection.',
        });
      } else if (error?.response?.status > 501) {
        window.location.href = '/error';
        return Promise.reject({
          isNetworkError: true,
          message: 'Unable to connect to the server. Please try again later.',
        });
      }

      return Promise.reject(error);
    },
  );

  return client;
};

export default client;
